module.exports = __webpack_public_path__ + "images/arrow-up-green-d6aa51e2.svg";